// components/AdvancedLazyImage.js
import React, { useState, useRef, useEffect, useCallback } from "react";

const AdvancedLazyImage = ({
  src,
  alt,
  className = "",
  imgclassName = "",
  width = "100%",
  height = "auto",
  placeholder = "/img/placeholder.jpg",
  threshold = 0.01,
  rootMargin = "100px",
  onLoad,
  onError,
}) => {
  const [imageState, setImageState] = useState({
    isLoaded: false,
    isInView: false,
    hasError: false,
  });

  const imgRef = useRef(null);
  const observerRef = useRef(null);

  const loadImage = useCallback(() => {
    const img = new Image();
    img.src = src;

    img.onload = () => {
      setImageState((prev) => ({ ...prev, isLoaded: true }));
      onLoad?.();
    };

    img.onerror = () => {
      setImageState((prev) => ({ ...prev, isLoaded: true, hasError: true }));
      onError?.();
    };
  }, [src, onLoad, onError]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setImageState((prev) => ({ ...prev, isInView: true }));
          loadImage();
          observer.disconnect();
        }
      },
      {
        threshold,
        rootMargin,
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
      observerRef.current = observer;
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [threshold, rootMargin, loadImage]);

  const { isLoaded, isInView, hasError } = imageState;
  const displaySrc = hasError ? placeholder : src;

  return (
    <div
      ref={imgRef}
      className={`advanced-lazy-image ${className}`}
      style={{
        width,
        height,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* شاشة التحميل */}
      {!isLoaded && (
        <div className="advanced-placeholder">
          <div className="shimmer-effect"></div>
          <div className="loading-indicator">
            <div className="spinner"></div>
            <span>جاري التحميل...</span>
          </div>
        </div>
      )}

      {/* الصورة */}
      {(isInView || isLoaded) && (
        <img
          src={displaySrc}
          alt={alt}
          className={imgclassName}
          style={{
            height: "100%",
            objectFit: "cover",
            width: "350px",
            transition: "all 0.5s ease-in-out",
            opacity: isLoaded ? 1 : 0.3,
            filter: isLoaded ? "none" : "blur(20px)",
            transform: isLoaded ? "scale(1)" : "scale(1.1)",
          }}
          loading="lazy"
          decoding="async"
        />
      )}
    </div>
  );
};

export default AdvancedLazyImage;
